module.exports = __webpack_public_path__ + "assets/a1e677080a50c56ccdc7576e753b50de.svg";